export function EducationBasicInformation() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Event Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200 shadow-sm">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* School Name */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              School Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter school name"
            />
          </div>

          {/* Grade Level */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Grade Level <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter grade level"
            />
          </div>

          {/* Teacher's Name */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Teacher's Name
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter teacher's name"
            />
          </div>

          {/* Class/Section */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Class/Section
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter class/section"
            />
          </div>

          {/* School Address */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              School Address
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter school address"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 